import { Box, Skeleton, Stack } from "@mui/material"

const ConciergeItemSkeleton = () => {
  return (
    <Box
      sx={{
        borderRadius: '16px',
        padding: '16px',
        boxShadow: '0px 2px 10px 0px #5B87EF33',
        mt: '16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexGrow: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
          pr: '8px'
        }}
      >
        <Stack
          sx={{
            mb: '8px',
          }}
          direction={'column'}
          spacing={1}
        >
          <Skeleton variant="rounded" width={'100%'} height={20} />
          <Skeleton variant="rounded" width={'100%'} height={20} />
        </Stack>
        <Box
          sx={{
            borderTop: '1px solid',
            borderColor: 'primary.lightGray',
            pt: '8px'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Skeleton variant="rounded" width={'100%'} height={20} />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          width: '100px',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <Skeleton variant="rounded" width={80} height={80} />
      </Box>
    </Box>
  )
}

export default ConciergeItemSkeleton